import React from 'react';
import Carousel from 'react-material-ui-carousel';
import autoBind from 'auto-bind';
import {
    Paper,
    CardMedia,
    Typography
} from '@material-ui/core';

import "../../styles/SecondExample.scss";

export default class Hero extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            autoPlay: true,
            timer: 500,
            animation: "slide",
            indicators: true,
            timeout: 300,
            navButtonsAlwaysVisible: false,
            valor: 0
        }

        autoBind(this);
    }

    toggleAutoPlay()
    {
        
        this.setState({
            autoPlay: !this.state.autoPlay,
        })
    }

    toggleIndicators()
    {
        this.setState({
            indicators: !this.state.indicators,
        })
    }

    toggleNavButtonsAlwaysVisible()
    {
        this.setState({
            navButtonsAlwaysVisible: !this.state.navButtonsAlwaysVisible,
        })
    }

    changeAnimation(event)
    {
        this.setState({
            animation: event.target.value,
        })
    }

    changeTimeout(event, value)
    {
        this.setState({
            timeout: value,
        })
    }

    render()
    {
        return (
            <div>

                <Carousel 
                    className="SecondExample"
                    autoPlay={true}
                    timer={this.state.timer}
                    animation={this.state.animation}
                    indicators={this.state.indicators}
                    timeout={this.state.timeout}
               
                    navButtonsAlwaysVisible={this.state.navButtonsAlwaysVisible}
                    
                >
                    {
                        this.props.dados.map( (item, index) => {
                            return (
                                <Paper 
                                    className="Project"
                                    style={{
                                        backgroundImage: require(`../../img/${item.img}`),
                                    }}
                                    elevation={10}
                                >
                                   <CardMedia
                                            className="Media"
                                            image={require(`../../img/${item.img}`)}
                                            title={item.titulo}
                                        >
                                            <div className="MediaCaption">
                                              <Typography className="h1">
                                                  {item.titulo}
                                              </Typography>
                                              <Typography className="h2">
                                                {item.conteudo}
                                            </Typography>
                                            </div>
                                    </CardMedia>
                                </Paper>
                            )
                        })
                    }
                </Carousel>                
            </div>
        )
    }
}